import react, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import NavBar from "../../../../components/NavBar";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Puff } from "react-loading-icons";
import EventTicketsRequest from './EventTicketsRequest'
import { Grid, EstadoCellRenderer } from "../../../Layout/Grid/GridView";
const EventTickets = () => {
    let params = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const gridRef = useRef();
    const [state, setState] = useState({
        tickets: [],
        event: {
            id: 0,
            name: "",
            id_venues: "",
        },
        modalCancelTicket: {
            show: false,
            info: {},
        },
        modalFormTableReservationInfo: {
            show: false,
            data: {
                table: {},
            },
        },
    });

    useEffect(() => {
        document.title = "Event Tickets | Nightspot Dashboard";
        getEventTicketsPurchased();
    }, []);

    const getEventTicketsPurchased = async (closeFormTableReservation = false) => {
        setIsLoading(true);
        let info = await EventTicketsRequest.getEventTicketsPurchased({
            id_events: params.id,
        });
        if (info && info.status) {
            setState(info.data);
        }
        setIsLoading(false);
    };


    const InsideLoading = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    <Puff stroke="#333" height="5em" width="5em" />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    Loading...
                </div>
            </div>
        );
    };



    // const ActionButton = (e) => {
    //     return (
    //         <div className="btn-group mb-2">
    //             <button type="button" className="btn btn-secondary dropdown-toggle " data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    //                 <i className="fa-solid fa-gears"></i>
    //             </button>
    //             <div className="dropdown-menu" >
    //                 <a className="dropdown-item" onClick={() => handlerGetInfoCancelTicket(e.data.id)}>Cancelar bilhete</a>
    //                 {/* <a className="dropdown-item" href="#">Another action</a>
    //                 <a className="dropdown-item" href="#">Something else here</a>
    //                 <div className="dropdown-divider"></div>
    //                 <a className="dropdown-item" href="#">Separated link</a> */}
    //             </div>
    //         </div>
    //     )
    // return (
    //     <div className="dropdown text-center">
    //         <a
    //             className="btn btn-secondary dropdown-toggle"
    //             role="button"
    //             id="dropdownMenuLink"
    //             data-bs-toggle="dropdown"
    //             aria-expanded="false"
    //         >
    //             <i className="fa-solid fa-gears"></i>
    //         </a>

    //         <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
    //             <li>
    //                 <a
    //                     className="dropdown-item"
    //                     href="#"
    //                     onClick={() => null}
    //                 >
    //                     <i className="fa-solid fa-pencil me-3"></i>Editar
    //                 </a>
    //             </li>
    //             <li>
    //                 <hr className="dropdown-divider" />
    //             </li>
    //             <li>
    //                 <a className="dropdown-item text-danger" href="#">
    //                     <i className="fa-solid fa-trash me-3"></i>Eliminar
    //                 </a>
    //             </li>
    //         </ul>
    //     </div>
    // );
    // };

    return (
        <div>
            <NavBar>
                <div className="row">
                    <div className="col-sm-12 dashboard-content">
                        {isLoading ? (
                            <InsideLoading />
                        ) : (
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <nav>
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <Link to="/my/dashboard">
                                                        <i className="fa-solid fa-home"></i>
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <Link to="/my/events/">Eventos</Link>
                                                </li>
                                                <li className="breadcrumb-item active">
                                                    Supervisão Bilhetes
                                                </li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-7">
                                        <h2 className="dashboard-h2">
                                            Evento: {state.event.name}{" "}
                                            <small style={{ color: "#ea2c61" }}>|</small>{" "}
                                            <small style={{ fontWeight: "100" }}>
                                                {state.event.date_formated}
                                            </small>
                                        </h2>
                                    </div>
                                    <div className="col-12 col-sm-5 ">
                                        <Link
                                            className="btn btn-primary float-end ms-3"
                                            to={`/my/events/${state.event.id}/tickets/transactions-list`}
                                        >
                                            <i className="fa-solid fa-money-bill-transfer"></i>
                                            &nbsp;Lista de pagamentos
                                        </Link>
                                        <Link
                                            className="btn btn-primary float-end ms-3"
                                            onClick={() => getEventTicketsPurchased()}
                                            to="#"
                                        >
                                            <i className="fa-solid fa-arrows-rotate"></i>&nbsp;
                                        </Link>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <Grid
                                            ref={gridRef}
                                            rows={state.tickets}
                                            cols={[
                                                { hide: true, field: "id" },
                                                { headerName: "Data Compra", field: "date_purchase" },
                                                { headerName: "Bilhete", field: "name" },
                                                { headerName: "Valor (€)", cellStyle: { textAlign: "right" }, field: "price" },
                                                { headerName: "Cliente", field: "client_name" },
                                                {
                                                    headerName: "Estado",
                                                    field: "status",
                                                    cellRenderer: EstadoCellRenderer,
                                                },
                                                // {
                                                //     headerName: "Ações",
                                                //     cellClass: "actions-button-cell text-center",
                                                //     cellRenderer: ActionButton,
                                                // }
                                            ]}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>


            </NavBar>
        </div>
    );

}

export default EventTickets;